import { createSlice } from "@reduxjs/toolkit";
import { LOGOUT } from "../../../utils/constants";
import {
  getCoursesBuilder,
  getCourseByIdBuilder,
  getFeaturedCoursesBuilder,
  getUserCoursesBuilder,
} from "./builder";

const initialState = {
  // Courses list
  courses: [],
  coursesLoading: false,

  // Featured courses for homepage
  featuredCourses: [],
  featuredLoading: false,

  // Selected course details
  selectedCourse: null,
  courseLoading: false,
  userCourse: null,
  hasAccess: false,

  // User's purchased courses
  userCourses: [],
  userCoursesLoading: true,
  userCoursesError: null,

  // Error handling
  error: null,
};

export const coursesSlice = createSlice({
  name: "courses",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.userCoursesError = null;
    },
    clearSelectedCourse: (state) => {
      state.selectedCourse = null;
      state.userCourse = null;
      state.hasAccess = false;
    },
    setSelectedCourse: (state, action) => {
      state.selectedCourse = action.payload;
    },
  },
  extraReducers: (builder) => {
    getCoursesBuilder(builder);
    getCourseByIdBuilder(builder);
    getFeaturedCoursesBuilder(builder);
    getUserCoursesBuilder(builder);
    // Pri odjavi se brišu SAMO privatni podaci (kupljeni kursevi, pristup).
    // Javni katalog (courses, featuredCourses) nema veze sa sesijom i ostaje —
    // potpuni reset je gostima brisao učitane kurseve sa početne strane.
    builder.addCase(LOGOUT, (state) => {
      state.userCourses = [];
      state.userCoursesLoading = true;
      state.userCoursesError = null;
      state.userCourse = null;
      state.hasAccess = false;
    });
  },
});

export const { clearError, clearSelectedCourse, setSelectedCourse } = coursesSlice.actions;

// Selectors
export const selectCourses = (state) => state.courses.courses;
export const selectCoursesLoading = (state) => state.courses.coursesLoading;

export const selectFeaturedCourses = (state) => state.courses.featuredCourses;
export const selectFeaturedLoading = (state) => state.courses.featuredLoading;

export const selectSelectedCourse = (state) => state.courses.selectedCourse;
export const selectCourseLoading = (state) => state.courses.courseLoading;
export const selectUserCourse = (state) => state.courses.userCourse;
export const selectHasAccess = (state) => state.courses.hasAccess;

export const selectUserCourses = (state) => state.courses.userCourses;
export const selectUserCoursesLoading = (state) => state.courses.userCoursesLoading;
export const selectUserCoursesError = (state) => state.courses.userCoursesError;

export const selectCoursesError = (state) => state.courses.error;

export default coursesSlice.reducer;
